import { ArrowRight } from "lucide-react";
import {
  buildRelaxiaUrl,
  detectCopyIssues,
  knownBusiness,
  knownSector,
  normalizeRelaxiaBaseUrl,
  trackRelaxiaCtaClick,
} from "../lib/relaxiaOffer";

const DEFAULT_TITLE = "¿Tus textos no convencen? Que la IA te los reescriba.";
const WEAK_COPY_TITLE = "Tu web pierde clientes en los textos. Arréglalo en un minuto.";
const BODY = "Tu análisis muestra puntos de mejora en tu web. Con Relaxia generas en un minuto un titular, una descripción y una llamada a la acción para tu negocio.";
const BUTTON = "Probar gratis: 3 textos sin tarjeta";
const NOTE = "Sin compromiso. Tú decides qué usar.";

export default function RelaxiaOffer({ data, checks, baseUrl }) {
  const resolvedBase = normalizeRelaxiaBaseUrl(
    baseUrl === undefined ? process.env.REACT_APP_RELAXIA_URL || "https://mejor-relax.vercel.app" : baseUrl
  );
  if (!resolvedBase) return null;

  const fallos = detectCopyIssues(data?.result, checks);
  const href = buildRelaxiaUrl({
    baseUrl: resolvedBase,
    web: data?.url,
    sector: knownSector(data),
    negocio: knownBusiness(data),
    fallos,
  });

  return (
    <aside
      className="mt-6 bg-gradient-to-br from-[#0F0F1A] to-[#1A0F2E] border border-[#9D4CDD]/20 rounded-2xl p-6 sm:p-8 text-center"
      data-testid="relaxia-offer"
      aria-labelledby="relaxia-offer-title"
    >
      <h3
        id="relaxia-offer-title"
        className="text-xl sm:text-2xl font-bold text-white mb-3 text-balance"
        style={{ fontFamily: "Cabinet Grotesk, sans-serif" }}
      >
        {fallos.length ? WEAK_COPY_TITLE : DEFAULT_TITLE}
      </h3>
      <p className="text-zinc-400 text-sm sm:text-base leading-relaxed max-w-2xl mx-auto mb-6">{BODY}</p>
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        onClick={trackRelaxiaCtaClick}
        data-testid="relaxia-cta"
        className="inline-flex w-full sm:w-auto items-center justify-center gap-2 px-6 sm:px-8 py-4 rounded-full bg-gradient-to-r from-[#9D4CDD] to-[#00E5FF] text-black font-bold text-sm sm:text-base hover:scale-105 active:scale-95 transition-all duration-200 shadow-[0_0_30px_rgba(157,76,221,0.3)] hover:shadow-[0_0_40px_rgba(157,76,221,0.5)]"
      >
        {BUTTON}
        <ArrowRight className="w-5 h-5 shrink-0" aria-hidden="true" />
      </a>
      <p className="mt-3 text-xs leading-5 text-zinc-500">{NOTE}</p>
    </aside>
  );
}
